<template>
  <Grid
    :loader="isLoading"
    :data-items="gridData"
    :columns="columns"
    :sort="sort"
    :sortable="true"
    :filter="filter"
    :filterable="filterable"
    :pageable="pageable"
    :skip="skip"
    :take="take"
    :total="total"
    @filterchange="filterChangeHandler"
    @sortchange="sortChangeHandler"
    @pagechange="pageChangeHandler"
  >
    <template v-slot:dateCell="{ props }">
      <td>
        {{ props.dataItem[props.field] | formatDateTime }}
      </td>
    </template>
    <template v-slot:actionCellTemplate="{ props }">
      <ActionCell
        :dataItem="props.dataItem"
        :onDelete="onDelete"
        :onExport="onExport"
        :onEdit="onEdit"
        :getTableData="getTableData"
      />
    </template>
  </Grid>
</template>

<script>
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { Grid } from '@progress/kendo-vue-grid';
import removeIcon from '../../assets/icons/remove.svg';
import ActionCell from './action-cell';

export default {
  name: 'NewDataTable',
  components: { Grid, ActionCell },
  props: {
    getPage: {
      type: Function,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    pageable: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: null,
    },
    perPage: {
      type: Number,
      default: 1000,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    onDelete: {
      type: Function,
      default: null,
    },
    onExport: {
      type: Function,
      default: null,
    },
    onEdit: {
      type: Function,
      default: null,
    },
  },
  data: function({ _props: currentProps }) {
    return {
      removeIcon,
      gridData: [],
      sort: [],
      filter: null,
      skip: 0,
      take: currentProps.perPage,
    };
  },
  async created() {
    await this.getTableData();
  },
  methods: {
    async getTableData() {
      const requestParams = {
        page: this.skip / this.take + 1,
        limit: this.take,
        sortBy: this.sort.length ? this.sort[0].field : '',
        sortOrder: this.sort.length ? this.sort[0].dir : '',
      };
      if (this.filter) {
        this.filter.filters.forEach(({ field, value }) => {
          requestParams[field] = value;
        });
      }
      const response = await this.getPage(requestParams);
      this.gridData = response.data || response;
    },
    async sortChangeHandler(e) {
      this.sort = e.sort;
      await this.getTableData();
    },
    async filterChangeHandler(e) {
      this.filter = e.filter;
      await this.getTableData();
    },
    async pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      await this.getTableData();
    },
  }
};
</script>

<style scoped lang="scss">
/deep/ .k-filtercell-operator > .k-dropdown-operator {
  display: none;
}
</style>
